import { getP } from 'redux-polyglot'
import api from '../libs/api'
import { showToast } from './app'

/**
 * Actions for retrieving user devices
 */
export const DEVICE_LIST_REQUEST = 'ACCOUNT/DEVICES/REQUEST'
export const DEVICE_LIST_SUCCESS = 'ACCOUNT/DEVICES/SUCCESS'
export const DEVICE_LIST_FAILURE = 'ACCOUNT/DEVICES/FAILURE'

const deviceListRequest = () => ({
  type: DEVICE_LIST_REQUEST
})

const deviceListSuccess = devices => ({
  type: DEVICE_LIST_SUCCESS,
  payload: devices
})

const deviceListFailure = error => ({
  type: DEVICE_LIST_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

const processDevices = data => {
  return data.map(device => ({
    id: device.id,
    name: device.name,
    type: device.type,
    serial: device.serial_number,
    lastUsed: device.updated > 0 ? device.updated : device.created,
    inUse: device.used_status === "in use"
  }))
}

export const loadDevices = () => (dispatch, getState) => {
  dispatch(deviceListRequest())
  return api.getDevices()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(deviceListSuccess(processDevices(response.devices)))
        } else {
          return dispatch(deviceListFailure(response.reason))
        }
      },
      () => dispatch(deviceListFailure(getP(getState()).t("tv_account.error_loading_account_devices", { _: "An error occurred while loading the list of account devices" })))
    )
}

/**
 * Actions for removing a device
 */
export const REMOVE_DEVICE_REQUEST = 'ACCOUNT/REMOVE/DEVICE/REQUEST'
export const REMOVE_DEVICE_SUCCESS = 'ACCOUNT/REMOVE/DEVICE/SUCCESS'
export const REMOVE_DEVICE_FAILURE = 'ACCOUNT/REMOVE/DEVICE/FAILURE'

const removeDeviceRequest = id => ({
  type: REMOVE_DEVICE_REQUEST,
  payload: {
    id
  }
})

const removeDeviceSuccess = id => ({
  type: REMOVE_DEVICE_SUCCESS,
  payload: {
    id
  }
})

const removeDeviceFailure = (id, error) => ({
  type: REMOVE_DEVICE_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
  meta: {
    id
  }
})

export const removeDevice = id => (dispatch, getState) => {
  dispatch(removeDeviceRequest(id))
  return api.removeDevice(id)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return Promise.all([
            dispatch(removeDeviceSuccess(id)),
            dispatch(showToast(getP(getState()).t("tv_account.device_removed", { _: "The selected device has been successfully removed" })))
          ])
        } else {
          return Promise.all([
            dispatch(removeDeviceFailure(id, response.reason)),
            dispatch(showToast(getP(getState()).t("tv_account.error_removing_device", { _: "An error occurred while trying to remove the selected device" }), 'error'))
          ])
        }
      },
      () => Promise.all([
        dispatch(removeDeviceFailure(id, response.reason)),
        dispatch(showToast(getP(getState()).t("tv_account.error_removing_device", { _: "An error occurred while trying to remove the selected device" }), 'error'))
      ])
    )
}
